module.exports = __webpack_public_path__ + "assets/retina_OuterTangentDetailed.c0f461ddb0e1edc0b3049933c3251259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_OuterTangentDetailed.png
// module id = 697
// module chunks = 0